if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.onThumbActivate = this.onThumbActivate.bind(this);
    }

    connectedCallback() {
      this.mainImage = this.querySelector('[data-main-image]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));

      if (!this.mainImage || !this.thumbs.length) return;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', this.onThumbActivate);
        thumb.addEventListener('keydown', (event) => this.onKeydown(event, thumb));
      });
    }

    onThumbActivate(event) {
      const thumb = event.currentTarget;
      this.activate(thumb);
    }

    onKeydown(event, thumb) {
      const idx = this.thumbs.indexOf(thumb);
      if (idx === -1) return;

      const last = this.thumbs.length - 1;
      let target = -1;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          target = idx === last ? 0 : idx + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          target = idx === 0 ? last : idx - 1;
          break;
        case 'Home':
          target = 0;
          break;
        case 'End':
          target = last;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.thumbs[target].focus();
      this.activate(this.thumbs[target]);
    }

    activate(thumb) {
      if (!thumb || thumb.classList.contains('is-active')) return;

      const src = thumb.dataset.thumbSrc;
      const srcset = thumb.dataset.thumbSrcset;
      const alt = thumb.dataset.thumbAlt || '';

      if (!src) return;

      // Swap main image
      if (srcset) this.mainImage.srcset = srcset;
      this.mainImage.src = src;
      this.mainImage.alt = alt;

      // Sync active state on all thumbs
      this.thumbs.forEach((t) => {
        const isActive = t === thumb;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('product-info', ProductInfo);
}
